import { userConstants } from './constantData';

export const NETWORK_AND_COLLECTION_PAGE_DATA = {
  network_page: {
    page_view: {
      hash: 'p-027.001.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_play_source', /* 21 */
        'v_provider_name', /* 35 */
      ],
    },
  },
  collection_page: {
    page_view: {
      hash: 'p-028.001.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_play_source', /* 21 */
        'v_collection_name', /* 36 */
      ],
    },
  },
};
